
const cinfo = ( ...args ) => console.info( 'NewsletterForm', new Date(), ...args );
const cerror = ( ...args ) => console.error( 'NewsletterForm', new Date(), ...args );

class NewsletterForm extends HTMLElement {

	/**
	 * Reference to the child form element within the newsletter section.
	 * @type {HTMLFormElement}
	 */
	_form = null;

	connectedCallback() {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this._start());
		} else {
			this._start();
		}
	}

	_start() {
		cinfo( 'newsletter form started' );

		if ( !this.endpoint ) throw new Error( 'SNF-002: Missing endpoint configuration' );

		this._form = this.querySelector( 'form' );
		if ( !this._form ) throw new Error( 'SNF-001: Could not find form element' );

		this._form.addEventListener( 'submit', this._onSubmit.bind( this ) );

		this.errorCode = '';
		this.status = 'ready';
	}

	
	/**
	 * Handles the form submission event.
	 * @param {SubmitEvent} e - The form submit event.
	 */
	_onSubmit(e) {
		e.preventDefault();

		this.errorCode = '';
		this.status = 'processing';

		const submitData = this._getFormData();
		fetch( this.endpoint, {
			method: 'POST',
			body: JSON.stringify( submitData ),
		} )
			.then( response => response.json() )
			.then( this._handleResponse.bind( this ) )
			.catch( err => {
				this.errorCode = 'GENERIC';
				this.status = 'ready';
			} );

	}

	_getFormData() {
		return Object.fromEntries( new FormData( this._form ) );
	}

	_handleResponse( responseData ) {
		if ( responseData.status === true ) {
			// Registration successful.
			this.status = 'done';
		} else {
			this.status = 'ready';
			this.errorCode = responseData.error;
		}
	}

	get endpoint() {
		return this.dataset.endpoint;
	}

	set errorCode(newErrorCode) {
		this.querySelectorAll( '[data-error]' ).forEach( el => el.style.display = 'none' );
		if ( newErrorCode && newErrorCode.length > 0 ) {
			// Try to find the specific message to show.
			// If not available, show the generic error message.
			const errorRefs = [
				this.querySelectorAll( `[data-error="${ newErrorCode }"]` ),
				this.querySelectorAll( `[data-error="GENERIC"]` )
			].find( arr => arr.length > 0 );
			errorRefs.forEach( el => el.style.display = 'block' );
		}
	}

	get status() {
		return this.dataset.status;
	}

	set status(newStatus) {
		this.dataset.status = newStatus;
	}

}

// Define the custom element
customElements.define('newsletter-form', NewsletterForm);
